import api from './api';

export interface ContactFormData {
  name: string;
  email: string;
  phone?: string;
  company?: string;
  message: string;
}

export interface ContactResponse {
  success: boolean;
  message: string;
  data?: {
    id: string;
    createdAt: string;
  };
  error?: string;
  details?: Array<{
    field: string;
    message: string;
  }>;
}

export const contactService = {
  async submitContact(data: ContactFormData): Promise<ContactResponse> {
    const response = await api.post<ContactResponse>('/contact', data);
    return response.data;
  },

  async getAllContacts(status?: string, page = 1, limit = 10) {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    params.append('page', page.toString());
    params.append('limit', limit.toString());

    const response = await api.get(`/contact?${params.toString()}`);
    return response.data;
  },

  async getContactById(id: string) {
    const response = await api.get(`/contact/${id}`);
    return response.data;
  },

  async updateContactStatus(id: string, status: string) {
    const response = await api.put(`/contact/${id}`, { status });
    return response.data;
  },

  async deleteContact(id: string) {
    const response = await api.delete(`/contact/${id}`);
    return response.data;
  },
};
